/**
 * Shared trip wizard step constants (CreateTripV2).
 * Legacy CreateTrip.js keeps its own copies for rollback.
 */

export const WIZARD_STEPS = [
    'Destination',
    'Packages',
    'Pricing',
    'Trip Logistics',
    'Departures',
    'Allocations',
    'Itineraries',
    'Add-On',
    'FAQs',
    'Review',
];

export const WIZARD_STEP_CONFIG_KEYS = [
    'overview',
    'packages',
    'pricing',
    'services',
    'departures',
    'allocations',
    'itineraries',
    'addons',
    'faqs',
    'review',
];

export const getStepConfigKey = (stepIndex) =>
    WIZARD_STEP_CONFIG_KEYS[stepIndex] || 'overview';

export const EMPTY_TRIP_FORM = {
    overview: { key_highlights: [], languages: [] },
    packages: {},
    pricing: {},
    services: {},
    departures: {},
    allocations: {},
    itineraries: {},
    addons: {},
    faqs: {},
};

/** Single trip-level publication status (draft / active / inactive). */
export const TRIP_STATUS_OPTIONS = [
    { value: 'draft', label: 'Draft' },
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Inactive' },
];
